module.exports = __webpack_public_path__ + "media/images/unfollow-18417c6edcd60e7c76d84a6ea8bbdebe.svg";